import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createComfort } from "../../helpers/http_comforts_requests";

export default function ComfortNew() {

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Formato de Produto",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createComfort(data, () => navigate('/confortos'))
    };

    return <DynamicFormPage title={"Confortos - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
